import './App.css';
import Homepage from './home';
import {Route, BrowserRouter,Navigate, Routes} from 'react-router-dom';
import Aboutus from './routes/about-us/aboutus';
import Contactus from './routes/contactus/contactus';
import ServiceConstruction from './routes/service-construction/construction';
import ServicePlots from './routes/service-plots/plots';
import Gallery from './routes/gallery/gallery';
import AdminPanel from './admin/admin';
import RoadWork from './routes/service-roadwork/road-work';
import Auth from './Auth/auth';
import { useState, useEffect } from 'react';
import { setUserId } from 'firebase/analytics';
import Profile from './Auth/profile';
import Dashborad from './Auth/dashboard';


function App() {
  
  

  const [user, setUser] = useState(null);

  useEffect(() => {
    let localUser = localStorage.getItem("adminuser")
    if(localUser){
      setUser(true)
    }  
    else if (localUser ===  null){
      setUser(false)
    }
  },[user])


 useEffect(()=>{
   const u = localStorage.getItem("adminuser");
   u && JSON.parse(u) ? setUser(true) : setUser(false);

   console.log("this is user ",user)

 },[]);  
 

  return (
    <div className="App">
   <BrowserRouter>
     <Routes>
       <Route path="/" element={<Homepage />} />
      
        {
          user && (
            <>
       <Route path="/admin/profile" element={<Profile logout={() => {
         setUser(false)
         localStorage.removeItem("adminuser");
        } } />} />
          <Route path="/admin/dashboard" element={<Dashborad  />} />
        
    <Route path="/admin-panel" element={<AdminPanel logout={() =>  setUser(false)} />} />
            </>
          )
        }

{ !user && (
  <>
      <Route path="/admin/auth"  element={<Auth authenticate={() =>{
        setUser(true)
    localStorage.setItem("adminuser",true);
          }} />} />
        </>
      )
    } 
        
      <Route path="/admin/auth"  element={<Auth authenticate={() =>{
          setUser(true)
    localStorage.setItem("adminuser",true);
          }} />} />
       <Route path="/about-us" element={<Aboutus />} />
       <Route path='/contact-us' element={<Contactus/>} />
       <Route path='/service-construction' element={<ServiceConstruction/>} />
       <Route path='/service-plots' element={<ServicePlots/>} />
       <Route path='/gallery' element={<Gallery/>} />
       <Route path="/service-roadwork" element={<RoadWork />} />

       <Route path="*" element={<h2 className='text-center' style={{marginTop:'20px'}}>Oops!.. Page Not Found..</h2>} />  
       {/* <Route path="*" element={<Navigate to={user ? "/admin/profile" : "admin/auth"} />} /> */}
     </Routes>
   </BrowserRouter>
    </div>
  );
}

export default App;
